import { render, staticRenderFns } from "./CoordinatesSelector.vue?vue&type=template&id=78d61ffb&"
import script from "./CoordinatesSelector.vue?vue&type=script&lang=js&"
export * from "./CoordinatesSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports